<template>
  <button
    :class="{ btnGreen__ghost: greenGhostClass }"
    @click="onClick"
    :disabled="disabled"
  >
    <span v-if="notJoinedOrPending && !owner">Join</span>
    <span v-if="isPending && !owner">Pending</span>
    <i class="fa fa-check" v-if="isJoined || owner"></i>
    <span v-if="isJoined && !owner">Joined</span>
    <span v-if="owner">Owner</span>
  </button>
</template>
<script>
import api from './api'
export default {
  name: "GroupJoinButton",
  props: ["groupId", "joined", "pending", "owner", "canLeave", "canJoin"],
  data() {
    return {
      isJoined: false,
      isPending: false,
      isLoading: false
    };
  },
  computed: {
    notJoinedOrPending() {
      return !this.isJoined && !this.isPending;
    },
    disabled() {
      return this.isPending || this.isLoading || this.owner;
    },
    greenGhostClass() {
      return this.isJoined || this.owner;
    }
  },
  methods: {
    onClick() {
      if (this.isJoined) {
        this.leave();
      } else {
        this.join();
      }
    },
    join() {
      this.setLoading();
      api
        .joinGroup(this.groupId)
        .then(this.joinSuccess)
        .catch(this.error);
    },
    leave() {
      this.setLoading();
      api
        .leaveGroup(this.groupId)
        .then(this.leaveSuccess)
        .catch(this.error);
    },
    setUnjoined() {
      this.isJoined = false;
      this.isPending = false;
    },
    setJoined() {
      this.isJoined = true;
      this.isPending = false;
    },
    setPending() {
      this.isJoined = false;
      this.isPending = true;
    },
    setLoading() {
      this.isLoading = true;
    },
    cancelLoading() {
      this.isLoading = false;
    },
    reset() {
      this.isLoading = false;
      this.isJoined = this.joined;
      this.isPending = this.pending;
    },
    joinSuccess(response) {
      if (!response.data.pending) {
        this.setJoined();
        this.cancelLoading();
      } else {
        this.setPending();
        this.cancelLoading();
      }
      this.$eventHub.$emit("addAlert", {
        type: "success",
        message: response.data.msg
      });
    },
    leaveSuccess(response) {
      this.setUnjoined();
      this.cancelLoading();
      this.$eventHub.$emit("addAlert", {
        type: "success",
        message: response.data.msg
      });
    },
    error() {
      this.reset();
      this.$eventHub.$emit("addAlert", {
        type: "error",
        message: "Something went wrong"
      });
    }
  },
  mounted() {
    this.reset();
  }
};
</script>
